export default "__VITE_PUBLIC_ASSET__b951815c__"